export const games = {
  gamesTitleDesktop: "打破联盟",
  gamesTitleMobile: "💥 打破联盟",
  gamesSubTitle: "他们不想给任何人留下机会。",
  recentTitle: "最新游戏",
  recentTitleMobile: "📢 最新游戏",
  recentTitleProvider: "{{provider}} 最新游戏",
  recentSubTitle: "尝试我们的新游戏，运气会眷顾你",
  recentSubTitleProvider: "{{provider}} 的新游戏",
  newLabel: "新",
  top10GamesTitle: "热门",
  top10GamesTitle2: "游戏",
  top10GamesSubTitleDesktop: "查看委内瑞拉最受欢迎的游戏",
  top10GamesSubTitleMobile: "委内瑞拉最受欢迎的十款游戏",
  top10GamesSubTitleDesktopProvider: "{{provider}} 最受欢迎的游戏",
  top10GamesSubTitleMobileProvider: "{{provider}} 最受欢迎的 <highlight>10</highlight> 款游戏",
  randomTitle: "无法决定？",
  randomTitleMobile: "🍀 让运气来决定！",
  randomDescription: "点击播放，让运气来决定。",
  randomDescriptionMobile: "点击播放，让运气来决定。",
  selectCategory: "选择一个类别",
  randomPlayButton: "开始游戏！",
  randomQuestion: "下一个给你带来好运的游戏会是哪一个？ 🍀",
  randomButton: "前往游戏 🚀",
  randomChipAll: "全部",
  randomTryAnother: "再试一次",
  randomNoGames: "此类别没有游戏",
  randomPromoTitle: "发现你的下一个最爱游戏",
  randomPromoText: "数千款游戏等着你。让运气为你选择，发现新体验。",
  randomPromoHint: "试试随机选择器 →",
  topPayingGamesTitle: "高额支付游戏",
  topPayingGamesSubTitle: "不断地撒钱",
  recentlyPlayedTitle: "继续游戏",
  recentlyPlayedSubTitle: "从上次中断的地方继续",
  favoritesPageTitle: "❤️ {{alias}}，这些是你的收藏",
  favoritesPageTitleGeneric: "❤️ 你的收藏游戏",
  favoritesPageSubtitle: "你最爱的游戏，汇聚一处",
  favoritesGridTitle: "{{alias}}的收藏",
  favoritesGridTitleGeneric: "你的收藏",
  favoritesEmptyMessage: "你还没有收藏任何游戏。点击心形图标标记你喜欢的游戏，随时回来玩你最爱的游戏。",
  favoritesAdd: "添加到收藏",
  favoritesRemove: "取消收藏",
  favoritesContinueTitle: "{{alias}}，继续你的游戏",
  favoritesContinueSubTitle: "回到你最近的游戏中",
  homeFavoritesCarouselTitle: "{{alias}}，玩你的收藏 ❤️",
  homeFavoritesCarouselTitleGeneric: "玩你的收藏 ❤️",
  homeFavoritesCarouselSubTitle: "你最爱的游戏，随时畅玩",
  lotteryGamesTitle: "彩票游戏",
  lotteryGamesSubTitle: "尝试我们的彩票游戏，试试您的运气",
  animalitosExpressTitle: "快速购买动物彩票",
  animalitosExpressSubTitle: "选择、购买、即时赢取",
  animalitosExpressBuy: "购买",
  animalitosExpressAll: "全部",
  qbErrorAmount: "请输入有效金额",
  qbErrorMinBet: "最低 {{min}} Bs",
  qbErrorMaxBet: "最高 {{max}} Bs",
  qbErrorBalance: "余额不足",
  qbErrorDrawClosed: "抽奖已关闭",
  qbSuccessTitle: "购买成功！",
  qbClose: "关闭",
  qbAriaLabel: "快速购买动物彩票",
  qbNextDraw: "抽奖",
  qbNoDraws: "暂无可用抽奖",
  qbDrawClosed: "已关闭",
  qbAmountLabel: "投注金额",
  qbConfirm: "确认购买",
  providerBgamingTitle: "BGAMING 游戏",
  providerBgamingSubtitle: "最好的 BGaming 游戏",
  providerEvoplayTitle: "EVO PLAY 游戏",
  providerEvoplaySubtitle: "Evo Play 无限乐趣",
  providerPragmaticTitle: "PRAGMATIC 游戏",
  providerPragmaticSubtitle: "Pragmatic Play 精选",
  allGamesTitle: "所有游戏",
  allGamesTitleProvider: "{{provider}} 的所有游戏",
  subcategoryAll: "全部",
  subcategoryShowMore: "查看更多",
  subcategoryShowLess: "收起",
  subcategoryFilterLabel: "按子类别筛选",
  dontMiss: "不要错过任何锦标赛",
  dontMissTournaments: "不要错过 Aprieta y Gana 的任何锦标赛",
  tournamentRules: "规则",
  promoFeatured: "精选活动",
  promoPrizePool: "奖金池",
  promoTimeLeft: "剩余时间",
  promoTimeLeftDays: "天",
  promoTimeLeftHours: "小时",
  promoTimeLeftMinutes: "分钟",
  promoPlayers: "玩家",
  promoRecentPlayers: "近期玩家",
  promoViewProfile: "资料",
  promoViewStories: "故事",
  promoAddContact: "添加",
  promoJoinNow: "立即加入",
  promoLearnMore: "了解更多",
  promoViewGames: "查看游戏",
  promoLive: "直播",
  promoCasinoLive: "最佳真人娱乐场",
  promoContests: "在线比赛",
  // Multi-Game Floating Button translations
  multiGameFloatingButton: "快速游戏",
  quickGamesTitle: "快速游戏",
  quickGamesDescription: "在等待主游戏时继续游戏！",
  hideQuickGames: "隐藏",
  minimizeQuickGames: "最小化",
  playNow: "立即游戏",
  noQuickGamesAvailable: "暂时没有可用的游戏",
  unknownGame: "未知游戏",
  unknownProvider: "未知",
  loadingGames: "正在加载游戏...",
  gameLoading: "加载游戏中",
  gameErrorTitle: "无法加载游戏",
  gameErrorDescription: "打开游戏时出现问题。请检查网络连接后重试。",
  gameRetry: "重试",
  gameGoBack: "返回",
  miniJuegosHeroTitle: "迷你游戏",
  miniJuegosHeroAccent: "快速",
  miniJuegosHeroSub: "快速、紧张、充满动作的游戏。几秒钟内赢得奖金。",
  miniJuegosStatGames: "游戏",
  miniJuegosStatCategories: "类别",
  miniJuegosCategories: "迷你游戏类别",
  miniJuegosLoading: "加载迷你游戏...",
  miniJuegosEmpty: "没有迷你游戏可用",
  miniJuegosCatAll: "全部",
  miniJuegosCat_crash: "碰撞游戏",
  miniJuegosCatSub_crash: "下注并在碰撞前提款",
  miniJuegosCat_chicken: "小鸡游戏",
  miniJuegosCatSub_chicken: "小鸡冒险和奖品",
  miniJuegosCat_mines: "扫雷",
  miniJuegosCatSub_mines: "避开地雷并获胜",
  miniJuegosCat_plinko: "弹珠台",
  miniJuegosCatSub_plinko: "投下并倍增",
  miniJuegosCat_sports: "运动",
  miniJuegosCatSub_sports: "休闲和运动游戏",
  miniJuegosCat_lottery: "彩票",
  miniJuegosCatSub_lottery: "刮刮卡、转盘，即刻赢取",

  // Hero Banner Slide 2 translations
  casinoSlide2Title: "体验 ",
  casinoSlide2Accent: "真人娱乐",
  casinoSlide2Sub: "轮盘、21点、百家乐等，专业真人荷官实时互动。",
  slotsSlide2Title: "无限 ",
  slotsSlide2Accent: "娱乐",
  slotsSlide2Sub: "数千款老虎机、桌面游戏等等在等着你。",
  miniJuegosSlide2Title: "即刻 ",
  miniJuegosSlide2Accent: "赢取",
  miniJuegosSlide2Sub: "Crash、扫雷、弹珠台等快速游戏，即时奖品。",
  lotterySlide2Title: "实时 ",
  lotterySlide2Accent: "开奖结果",
  lotterySlide2Sub: "关注您喜爱的抽奖并即刻领取奖金。",
  horsesSlide2Title: "实时 ",
  horsesSlide2Accent: "投注",
  horsesSlide2Sub: "国内外赛马直播，实时投注。",
  gameSearchPlaceholder: "搜索游戏...",
  gameSearchAriaLabel: "搜索游戏",
  gameSearchClear: "清除搜索",
  gameSearchFilters: "筛选",
  gameSearchRemoveFilter: "移除筛选",
  gameSearchClearFilters: "清除所有筛选",
  gameSearchProviders: "供应商",
  gameSearchCategories: "类别",
  gameSearchResults: "结果",
  categoryDice: "骰子",
  categoryFishing: "捕鱼",
  categoryVirtualSports: "虚拟体育",
  categoryTableGames: "桌游",
  categoryDomino: "多米诺",
  categoryPoker: "扑克",
};
